import React from 'react';
import { SpacerRow, Grid, Spinner, SpinnerSize, TextInput, Button } from 'ui-toolkit';
import { RemittanceItem } from './RemittanceItem';
import { IRemittanceAndCDItemData } from './attachCDItemsToRemittanceItems';
import { IFetchStatus } from '../../../../types/rest/IFetchStatus';

export interface IRemittanceListProps {
  remittanceCDItemPairs: IRemittanceAndCDItemData[];
  fetchStatus: IFetchStatus;
  onSend: () => void;
}

const LoadingIndicator = () => (
  <Grid columnCount={2} alignItems={'center'} templateColumns={'repeat(2, auto)'}>
    <Spinner size={SpinnerSize.small} />
    <div>Sending...</div>
  </Grid>
);

export const RemittanceList: React.FC<IRemittanceListProps> = ({ remittanceCDItemPairs, onSend, fetchStatus }) => {
  return (
    <>
      <div>
        <Grid columnCount={3}>
          <div>
            <label>Account Name</label>
            <div>
              <TextInput disabled value={'American Digital Title Insurance Company'} />
            </div>
          </div>
          <div />
          <div />
        </Grid>
        {remittanceCDItemPairs.map((item) => (
          <RemittanceItem key={item.remittance.id} cdItem={item.cdItem} remittance={item.remittance} />
        ))}
        <SpacerRow />
        {fetchStatus.fetched && (
          <Button type="button" intent="primary" disabled={fetchStatus.fetching} onClick={onSend}>
            {fetchStatus.fetching ? <LoadingIndicator /> : 'Send'}
          </Button>
        )}
      </div>
      <hr />
    </>
  );
};
